require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.function.name");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("@tinacms/react-modals"), require("@tinacms/media"), require("@tinacms/react-forms"), require("@tinacms/react-screens"), require("@tinacms/fields"), require("@tinacms/form-builder"), require("@tinacms/react-core"), require("react"), require("@tinacms/icons"), require("@tinacms/styles"), require("@tinacms/react-sidebar"), require("@tinacms/react-toolbar"), require("@tinacms/core"), require("@tinacms/alerts"), require("styled-components"), require("@tinacms/react-alerts"), require("@tinacms/forms")) : "function" == typeof define && define.amd ? define(["exports", "@tinacms/react-modals", "@tinacms/media", "@tinacms/react-forms", "@tinacms/react-screens", "@tinacms/fields", "@tinacms/form-builder", "@tinacms/react-core", "react", "@tinacms/icons", "@tinacms/styles", "@tinacms/react-sidebar", "@tinacms/react-toolbar", "@tinacms/core", "@tinacms/alerts", "styled-components", "@tinacms/react-alerts", "@tinacms/forms"], t) : t((e = e || self).tinacms = {}, e.reactModals, e.media, e.reactForms, e.reactScreens, e.fields, e.formBuilder, e.reactCore, e.React, e.icons, e.styles, e.reactSidebar, e.reactToolbar, e.core, e.alerts, e.styled, e.reactAlerts, e.forms);
}(this, function (t, l, s, r, e, i, n, f, m, o, d, p, b, a, y, u, g, c) {
  "use strict";

  var h = "default" in m ? m["default"] : m;
  u = u && u.hasOwnProperty("default") ? u["default"] : u;

  var P = function P(e, t, n) {
    this.form = e, this.__type = "screen", this.name = e.label, this.Icon = t || o.SettingsIcon, this.layout = n || "popup", this.Component = function () {
      return m.createElement(r.FormView, {
        activeForm: e
      });
    };
  };

  var _v = function v(e, t) {
    return (_v = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }
    })(e, t);
  };

  var _O = function O() {
    return (_O = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var i in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  function w(o, a, u, c) {
    return new (u = u || Promise)(function (e, t) {
      function n(e) {
        try {
          i(c.next(e));
        } catch (e) {
          t(e);
        }
      }

      function r(e) {
        try {
          i(c["throw"](e));
        } catch (e) {
          t(e);
        }
      }

      function i(t) {
        t.done ? e(t.value) : new u(function (e) {
          e(t.value);
        }).then(n, r);
      }

      i((c = c.apply(o, a || [])).next());
    });
  }

  function j(n, r) {
    var i,
        o,
        a,
        e,
        u = {
      label: 0,
      sent: function sent() {
        if (1 & a[0]) throw a[1];
        return a[1];
      },
      trys: [],
      ops: []
    };
    return e = {
      next: t(0),
      "throw": t(1),
      "return": t(2)
    }, "function" == typeof Symbol && (e[Symbol.iterator] = function () {
      return this;
    }), e;

    function t(t) {
      return function (e) {
        return function (t) {
          if (i) throw new TypeError("Generator is already executing.");

          for (; u;) {
            try {
              if (i = 1, o && (a = 2 & t[0] ? o["return"] : t[0] ? o["throw"] || ((a = o["return"]) && a.call(o), 0) : o.next) && !(a = a.call(o, t[1])).done) return a;

              switch (o = 0, a && (t = [2 & t[0], a.value]), t[0]) {
                case 0:
                case 1:
                  a = t;
                  break;

                case 4:
                  return u.label++, {
                    value: t[1],
                    done: !1
                  };

                case 5:
                  u.label++, o = t[1], t = [0];
                  continue;

                case 7:
                  t = u.ops.pop(), u.trys.pop();
                  continue;

                default:
                  if (!(a = 0 < (a = u.trys).length && a[a.length - 1]) && (6 === t[0] || 2 === t[0])) {
                    u = 0;
                    continue;
                  }

                  if (3 === t[0] && (!a || t[1] > a[0] && t[1] < a[3])) {
                    u.label = t[1];
                    break;
                  }

                  if (6 === t[0] && u.label < a[1]) {
                    u.label = a[1], a = t;
                    break;
                  }

                  if (a && u.label < a[2]) {
                    u.label = a[2], u.ops.push(t);
                    break;
                  }

                  a[2] && u.ops.pop(), u.trys.pop();
                  continue;
              }

              t = r.call(n, u);
            } catch (e) {
              t = [6, e], o = 0;
            } finally {
              i = a = 0;
            }
          }

          if (5 & t[0]) throw t[1];
          return {
            value: t[0] ? t[1] : void 0,
            done: !0
          };
        }([t, e]);
      };
    }
  }

  var S,
      F,
      M,
      E = {
    __type: "field",
    name: "date",
    Component: x("Date", "https://github.com/tinacms/tinacms/pull/1281")
  },
      C = {
    __type: "field",
    name: "markdown",
    Component: x("Markdown", "https://github.com/tinacms/tinacms/pull/1134")
  },
      _ = {
    __type: "field",
    name: "html",
    Component: x("HTML", "https://github.com/tinacms/tinacms/pull/1134")
  },
      q = u.p.withConfig({
    displayName: "PlaceholderParagraph",
    componentId: "sc-13o93pv"
  })(M || (S = ["\n  white-space: normal;\n  font-size: var(--tina-font-size-2);\n  margin: 8px 0 0 0;\n\n  a {\n    color: var(--tina-color-primary);\n  }\n"], F = ["\n  white-space: normal;\n  font-size: var(--tina-font-size-2);\n  margin: 8px 0 0 0;\n\n  a {\n    color: var(--tina-color-primary);\n  }\n"], Object.defineProperty ? Object.defineProperty(S, "raw", {
    value: F
  }) : S.raw = F, M = S));

  function x(t, n) {
    return function (e) {
      return h.createElement(i.FieldMeta, {
        name: e.input.name,
        label: "Deprecated: " + t + " Field"
      }, h.createElement(q, null, "In order to help improve bundle sizes the ", t, " Field has been removed from the set of default fields."), h.createElement(q, null, "See the docs to learn how to", " ", h.createElement("a", {
        href: "https://tinacms.org/docs/cms/plugins#adding-plugins",
        target: "_blank",
        rel: "noreferrer noopener"
      }, "add the ", t, " plugin"), " ", "to your CMS."), h.createElement(q, null, "Visit the", " ", h.createElement("a", {
        href: n,
        target: "_blank",
        rel: "noreferrer noopener"
      }, "Pull Request"), " ", "to learn more about why this change was made."));
    };
  }

  var T,
      k,
      I,
      G = [i.TextFieldPlugin, i.TextareaFieldPlugin, i.ImageFieldPlugin, i.ColorFieldPlugin, i.NumberFieldPlugin, i.ToggleFieldPlugin, i.SelectFieldPlugin, i.GroupFieldPlugin, i.GroupListFieldPlugin, i.ListFieldPlugin, i.BlocksFieldPlugin, i.TagsFieldPlugin, C, _, E],
      R = (I = a.CMS, _v(T = L, k = I), void (T.prototype = null === k ? Object.create(k) : (A.prototype = k.prototype, new A())), Object.defineProperty(L.prototype, "forms", {
    get: function get() {
      return this.plugins.findOrCreateMap("form");
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(L.prototype, "fields", {
    get: function get() {
      return this.plugins.findOrCreateMap("field");
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(L.prototype, "screens", {
    get: function get() {
      return this.plugins.findOrCreateMap("screen");
    },
    enumerable: !0,
    configurable: !0
  }), L);

  function A() {
    this.constructor = T;
  }

  function L(e) {
    void 0 === e && (e = {});

    var t = e.sidebar,
        n = e.media,
        r = e.toolbar,
        i = function (e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var i = 0;

        for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) {
          t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
        }
      }

      return n;
    }(e, ["sidebar", "media", "toolbar"]),
        o = I.call(this, i) || this;

    o.alerts = new y.Alerts(o.events);
    var a = (null == n ? void 0 : n.store) || new z();

    if (o.media = new s.MediaManager(a), t) {
      var u = "object" == typeof t ? t : void 0;
      o.sidebar = new p.SidebarState(o.events, u);
    }

    if (r) {
      var c = "object" == typeof r ? r : void 0;
      o.toolbar = new b.ToolbarState(c);
    }

    return G.forEach(function (e) {
      o.fields.find(e.name) || o.fields.add(e);
    }), o;
  }

  var z = (N.prototype.persist = function (t) {
    return w(this, void 0, void 0, function () {
      return j(this, function (e) {
        return alert("UPLOADING FILES"), console.log(t), [2, t.map(function (e) {
          return {
            directory: e.directory,
            filename: e.file.name
          };
        })];
      });
    });
  }, N.prototype.previewSrc = function (t) {
    return w(this, void 0, void 0, function () {
      return j(this, function (e) {
        return [2, t];
      });
    });
  }, N);

  function N() {
    this.accept = "*";
  }

  function B(e) {
    var t = e.cms,
        n = e.children,
        r = e.position,
        i = e.styled,
        o = void 0 === i || i,
        a = m.useState(t.enabled),
        u = a[0],
        c = a[1];
    if (m.useEffect(function () {
      return t.events.subscribe("cms", function () {
        c(t.enabled);
      });
    }, []), !(t instanceof R)) throw new Error("The `cms` prop must be an instance of `TinaCMS`.");
    return m.createElement(f.CMSContext.Provider, {
      value: t
    }, m.createElement(l.ModalProvider, null, m.createElement(g.Alerts, {
      alerts: t.alerts
    }), u && o && m.createElement(d.Theme, null), u && t.toolbar && m.createElement(b.Toolbar, null), t.sidebar ? m.createElement(p.SidebarProvider, {
      position: r,
      sidebar: t.sidebar
    }, n) : n));
  }

  var V = B;
  Object.keys(l).forEach(function (e) {
    "default" !== e && Object.defineProperty(t, e, {
      enumerable: !0,
      get: function get() {
        return l[e];
      }
    });
  }), Object.keys(s).forEach(function (e) {
    "default" !== e && Object.defineProperty(t, e, {
      enumerable: !0,
      get: function get() {
        return s[e];
      }
    });
  }), Object.keys(i).forEach(function (e) {
    "default" !== e && Object.defineProperty(t, e, {
      enumerable: !0,
      get: function get() {
        return i[e];
      }
    });
  }), Object.keys(n).forEach(function (e) {
    "default" !== e && Object.defineProperty(t, e, {
      enumerable: !0,
      get: function get() {
        return n[e];
      }
    });
  }), Object.defineProperty(t, "ActionButton", {
    enumerable: !0,
    get: function get() {
      return r.ActionButton;
    }
  }), Object.defineProperty(t, "useScreenPlugin", {
    enumerable: !0,
    get: function get() {
      return e.useScreenPlugin;
    }
  }), Object.defineProperty(t, "CMSContext", {
    enumerable: !0,
    get: function get() {
      return f.CMSContext;
    }
  }), Object.defineProperty(t, "ERROR_MISSING_CMS", {
    enumerable: !0,
    get: function get() {
      return f.ERROR_MISSING_CMS;
    }
  }), Object.defineProperty(t, "useForm", {
    enumerable: !0,
    get: function get() {
      return f.useForm;
    }
  }), Object.defineProperty(t, "useLocalForm", {
    enumerable: !0,
    get: function get() {
      return f.useLocalForm;
    }
  }), Object.defineProperty(t, "usePlugin", {
    enumerable: !0,
    get: function get() {
      return f.usePlugin;
    }
  }), Object.defineProperty(t, "usePlugins", {
    enumerable: !0,
    get: function get() {
      return f.usePlugins;
    }
  }), Object.defineProperty(t, "useSubscribable", {
    enumerable: !0,
    get: function get() {
      return f.useSubscribable;
    }
  }), Object.defineProperty(t, "useWatchFormValues", {
    enumerable: !0,
    get: function get() {
      return f.useWatchFormValues;
    }
  }), Object.defineProperty(t, "withPlugin", {
    enumerable: !0,
    get: function get() {
      return f.withPlugin;
    }
  }), Object.defineProperty(t, "withPlugins", {
    enumerable: !0,
    get: function get() {
      return f.withPlugins;
    }
  }), Object.defineProperty(t, "Form", {
    enumerable: !0,
    get: function get() {
      return c.Form;
    }
  }), t.CMS = R, t.GlobalFormPlugin = P, t.Tina = V, t.TinaCMS = R, t.TinaProvider = B, t.useCMS = function () {
    return f.useCMS();
  }, t.useFormScreenPlugin = function (e) {
    var t = m.useMemo(function () {
      if (e) return new P(e);
    }, [e]);
    f.usePlugins(t);
  }, t.useGlobalForm = function (e, t) {
    void 0 === t && (t = {});
    var n = f.useForm(e, t),
        r = n[0],
        i = n[1],
        o = m.useMemo(function () {
      if (i) return new P(i);
    }, [i]);
    return f.usePlugins(o), [r, i];
  }, t.withTina = function (n, r) {
    return function (e) {
      var t = m.useMemo(function () {
        return new R(r);
      }, [r]);
      return m.createElement(B, {
        cms: t
      }, m.createElement(n, _O({}, e)));
    };
  }, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});